import { cn } from "cn";
import type { FC } from "react";
import React from "react";

import {
  getAntialiasedSizePx,
  getMinAntialiasedSizePx,
} from "@react/foundation/browser";

import type { HealthProbeStatus } from "@apis/monitoring/models";

import { useHealthProbes } from "../hooks/useHealthProbes.ts";

function getStatusColor(status: HealthProbeStatus | null): string {
  switch (status) {
    case "failing":
      return "bg-destructive";
    case "healthy":
      return "bg-success";
    case null:
      return "bg-muted-foreground";
    case "warning":
      return "bg-warning";
  }
}

interface HealthHistoryCompactProps {
  readonly limit?: number;
  readonly name: string;
  readonly target: string;
}

export const HealthHistoryCompact: FC<HealthHistoryCompactProps> = ({
  limit = 50,
  name,
  target,
}) => {
  const probes = useHealthProbes({ limit, target });

  const TARGET_SIZE_PX = 12;
  const ANTIALIASED_SIZE_PX = getAntialiasedSizePx(TARGET_SIZE_PX);

  const ANTIALIASED_MARGIN_PX = getMinAntialiasedSizePx();

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <div className="text-sm font-medium text-foreground">{name}</div>
      </div>
      <div className="flex flex-row flex-wrap items-center">
        {probes.map((status, index) => (
          <div
            className={cn("rounded-xs", getStatusColor(status))}
            key={index}
            style={{
              height: `${ANTIALIASED_SIZE_PX}px`,
              marginRight: `${ANTIALIASED_MARGIN_PX}px`,
              width: `${ANTIALIASED_SIZE_PX}px`,
            }}
          />
        ))}
      </div>
    </div>
  );
};
